exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.extraImg[data-v-07175cda] {\n  margin-top: -60px;\n  text-align: center;\n  width: 195px;\n}\n.extraImg img[data-v-07175cda] {\n  width: 100%;\n}\n", "", {"version":3,"sources":["/app/src/layouts/PageView.vue","/app/src/layouts/PageView.vue"],"names":[],"mappings":";AAkDA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;CCjDD;AD8CD;EAKI,YAAA;CChDH","file":"PageView.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.extraImg{\n  margin-top: -60px;\n  text-align: center;\n  width: 195px;\n  img{\n    width: 100%;\n  }\n}\n",".extraImg {\n  margin-top: -60px;\n  text-align: center;\n  width: 195px;\n}\n.extraImg img {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07175cda","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/PageView.vue
// module id = 17tI
// module chunks = 2